<template>
	<div
		:class="[
			'select-input',
			{
				'select-input--label': label,
				'select-input__full': inputFull,
				'select-input__big': bigSize,
			},
		]"
	>
		{{ label }}
		<select
			v-if="!label"
			v-model="selectModel"
			:class="[
				'select-input__select',
				{
					'select-input__select__big': bigSize,
				},
			]"
			@change="selectChange"
			@keydown.enter="$emit('enter')"
		>
			<option
				v-for="item in selectList"
				:key="item.value"
				:value="item.value"
			>
				{{ item.name }}
			</option>
		</select>
		<date-range
			v-if="usePeriod"
			:value="{ from, to }"
			ref="period"
			type="date"
			:class="[
				'select-input__period',
				{
					'select-input__period--label': label,
				},
			]"
			@input="changePeriod"
			@enter="$emit('enter')"
		/>
		<input
			v-else
			v-model="inputModel"
			type="text"
			:placeholder="placeholder"
			:class="[
				'select-input__input',
				{
					'select-input__input--label': label,
					'select-input__input__big': bigSize,
				},
			]"
			@keydown.enter="$emit('enter')"
			@input="inputInput"
		/>
	</div>
</template>
<script>
	import debounce from 'lodash/debounce';
	import DateRange from '@/components/DateRange';

	export default {
		name: 'SelectInput',
		components: { DateRange },
		props: {
			usePeriod: {
				type: Boolean,
				default: false,
			},
			selectList: {
				type: Array,
				default: () => [],
			},
			placeholder: {
				type: String,
				default: '',
			},
			defaultSelectValue: {
				type: [String, Number],
				default: null,
			},
			label: {
				type: String,
				default: '',
			},
			useRealtimeSearch: {
				type: Boolean,
				default: false,
			},
			inputFull: {
				type: Boolean,
				default: false,
			},
			bigSize: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				selectModel: this.defaultSelectValue,
				from: '',
				to: '',
				inputModel: '',
			};
		},
		methods: {
			emitChange() {
				this.$emit('change', {
					select: this.selectModel,
					from: this.from,
					to: this.to,
					input: this.inputModel,
				});
			},
			selectChange() {
				this.emitChange();
			},
			changePeriod({ from, to }) {
				this.inputModel = '';
				this.from = from;
				this.to = to;
				this.emitChange();
			},
			search: debounce(function () {
				this.$emit('search');
			}, 500),
			inputInput(e) {
				this.from = '';
				this.to = '';
				this.inputModel = e.target.value;
				this.emitChange();
				if (this.useRealtimeSearch) {
					this.search();
				}
			},
			init() {
				if (this.selectList.length)
					this.selectModel = this.selectList[0].value;
				this.from = '';
				this.to = '';
				this.inputModel = '';
			},
		},
	};
</script>
<style lang="scss" scoped>
	$height: 36px;
	$bigHeight: $height * 1.5;

	div {
		.select-input {
			display: flex;
			height: $height;
			border: solid 1px #e5ebf2;
			flex-shrink: 0;
			&__full {
				width: 100%;
			}
			&__big {
				height: $bigHeight;
			}
		}

		.select-input--label {
			background: #e5ebf2;
			padding-left: 12px;
			line-height: 35px;
			white-space: nowrap;
		}

		.select-input__select {
			display: block;
			height: $height;
			background-color: #e5ebf2;
			padding: 0 12px;
			&__big {
				height: $bigHeight;
			}
			&:focus {
				outline: 1px solid #0099fa;

				& + .select-input__input {
					border-left: 1px solid #0099fa;
				}

				&
					+ .select-input__period
					::v-deep
					.range__from
					.date__box__input {
					border-left: 1px solid #0099fa;
				}
			}
		}

		::v-deep .date__box__input:focus {
			outline: 1px solid #0099fa;
		}

		.select-input__input {
			display: block;
			width: 280px;
			height: inherit;
			border-radius: 0 !important;
			border: none;
			border-left: solid 1px #e5ebf2;
			&__big {
				height: $bigHeight !important;
			}
			&.select-input__full {
				width: 100%;
			}

			&:hover {
				border-color: #e5ebf2;
			}

			&:focus {
				border-color: #e5ebf2;
				outline: 1px solid #0099fa;
			}
		}

		.select-input__period--label,
		.select-input__input--label {
			margin-left: 12px;
		}

		.select-input .range ::v-deep {
			.date,
			.date__box,
			.range__divider {
				height: 100%;
			}

			.date:last-of-type {
				.date__box__input {
					border-right: 0;
				}
			}

			.date__box__input {
				height: 100%;
				border-left-width: 0;
				border-top-width: 0;
				border-bottom-width: 0;
				border-color: #e5ebf2 !important;

				&:hover {
					border-color: #e5ebf2;
				}

				&:focus {
					border-color: #e5ebf2;
				}
			}
		}
	}
</style>
